export const viewEmailFromNoteLabel = "RbrV4d";
export default {viewEmailFromNoteLabel};